var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe{border:none;height:100%;position:absolute;width:100%}body{overflow-x:hidden;margin:0;background:#1785c8 url(" + escape(require("../static/images/Background.svg")) + ") no-repeat;background-size:cover}body .bold{font-weight:800}@media only screen and (min-width: 320px) and (max-width: 767px){body{background:none !important}}@media only screen and (max-width: 319px){body{background:none !important}}@media only screen and (min-width: 1921px){body{background:#1785c8 url(" + escape(require("../static/images/BackgroundLargeScreen.png")) + ") no-repeat;background-size:cover}}\n", ""]);

// exports
